export const getAlphanumericDigits = (string: string) => {
  return string ? string.replace(/\W/g, '') : ''
}

export const getOnlyDigits = (string: string) => {
  return string ? string.replace(/[^\d]/g, '') : ''
}
